import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { I18nProvider } from "../_flyingPaws/i18n/i18nProvider";
import { LayoutProvider, LayoutSplashScreen } from "../_flyingPaws/layout/core";
import { MasterInit } from "../_flyingPaws/layout/MasterInit";
import { AuthInit } from "./modules/auth";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <AuthInit>
            <ToastContainer />
            <Outlet />
            <MasterInit />
          </AuthInit>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  );
};

export { App };
